import { Rectangle } from "@/shared/sync/mediaRepository/rectangle"

export class MagicDesignTextInfo {
    box_coordinates: Rectangle
    box_text: string
    box_angle: number
    font_name: string
    has_shadow: boolean
    has_outline: boolean
    shadow_kernel_class: number
    shadow_opacity_class: string
    shadow_direction_class: number
    shadow_amplitude: number
    outline_color: string
    outline_width: number
    text_color: string
    font_height: number
}